
    // this file was auto generated by python script
    // this icon was sourced from feather icons 4.2.8
    import React from 'react';
    const Disc = () => (
      <>
        <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="3"></circle>
      </>
    );
    export default Disc;
    